module.exports = "p {\n  font-size: 0.8em; }\n\n.card {\n  height: 100%;\n  padding-bottom: 10px; }\n\n.card-body {\n  -webkit-box-flex: 0;\n      -ms-flex: none;\n          flex: none; }\n\n.list-group {\n  padding-left: 5px; }\n\n.list-group-item {\n  border: none; }\n\n.info-panel {\n  margin: 20px 0; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/home/home.scss
// module id = ./src/app/pages/home/home.scss
// module chunks = main